import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  Stack,
  Chip,
  Grid,
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import downloadFill from "@iconify-icons/eva/download-fill";
import monitorFill from "@iconify-icons/eva/monitor-fill";
import { useSelector } from "src/redux/store";
import WORKER_DOWNLOADS from "src/utils/workerDownloads";

// ----------------------------------------------------------------------
//   Step 5 · Worker. Muestra el link de descarga + estado en vivo
//   (conectado / desconectado — desde slice workerStatus si existe).
// ----------------------------------------------------------------------

// Del entorno de este Front (producción o dev): ver utils/workerDownloads.
const WORKER_DOWNLOAD_URL = WORKER_DOWNLOADS.windows;
const WORKER_ANDROID_URL = WORKER_DOWNLOADS.android;

export default function StepWorker({ onComplete, onSkip }) {
  // Si el slice workerStatus expone conectividad, la usamos para
  // detectar si el Worker ya está online y avanzar automáticamente.
  const workerStatus = useSelector((s) => s.workerStatus || {});
  const isConnected = workerStatus.isConnected || false;

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Instala el Worker
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        El Worker es un pequeño programa que gestiona impresoras, cajón portamonedas
        y KDS desde tu PC/tablet. Solo se instala una vez.
      </Typography>

      {isConnected && (
        <Card sx={{ p: 2, mb: 2, bgcolor: "success.lighter", display: "flex", alignItems: "center", gap: 2 }}>
          <Icon icon={monitorFill} width={32} style={{ color: "#16a34a" }} />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: "success.darker" }}>
              Worker detectado y conectado
            </Typography>
            <Typography variant="caption" sx={{ color: "success.darker" }}>
              Ya está funcionando. Puedes continuar.
            </Typography>
          </Box>
        </Card>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3, textAlign: "center", height: "100%" }}>
            <Typography sx={{ fontSize: 40 }}>🖥️</Typography>
            <Typography variant="h6" sx={{ fontWeight: 800, mt: 1 }}>Windows</Typography>
            <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 2 }}>
              Windows 10 / 11 · 60 MB
            </Typography>
            <Button
              variant="contained"
              color="success"
              startIcon={<Icon icon={downloadFill} />}
              component="a"
              href={WORKER_DOWNLOAD_URL}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
            >
              Descargar Worker
            </Button>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 3, textAlign: "center", height: "100%" }}>
            <Typography sx={{ fontSize: 40 }}>📱</Typography>
            <Typography variant="h6" sx={{ fontWeight: 800, mt: 1 }}>Android</Typography>
            <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 2 }}>
              Tablet o móvil Android 8+
            </Typography>
            <Button
              variant="outlined"
              component="a"
              href={WORKER_ANDROID_URL}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
            >
              Ver en Play Store
            </Button>
          </Card>
        </Grid>
      </Grid>

      <Card sx={{ p: 2.5, mt: 3, bgcolor: "grey.50" }}>
        <Typography variant="overline" sx={{ color: "text.secondary", fontWeight: 700 }}>Instrucciones rápidas</Typography>
        <Stack spacing={0.5} sx={{ mt: 1 }}>
          <Typography variant="body2">1. Descarga e instala en el PC/tablet donde tengas las impresoras conectadas.</Typography>
          <Typography variant="body2">2. Al abrir, introduce tu email de TakeMyOrder para vincular.</Typography>
          <Typography variant="body2">3. Vuelve aquí y pulsa "Ya lo tengo" para continuar.</Typography>
        </Stack>
      </Card>

      <Stack direction="row" spacing={2} justifyContent="space-between" sx={{ mt: 4 }}>
        <Button onClick={onSkip} color="inherit">Lo instalo luego</Button>
        <Button variant="contained" color="success" onClick={() => onComplete()}>
          Ya lo tengo →
        </Button>
      </Stack>
    </Box>
  );
}
